import clsx from 'clsx'
import { ICONS } from '@Const/common'
import React from 'react'
import WizardStepIndicatorType from '@Components/WizardFlow/WizardStepIndicator/wizard-step-indicator-type'

interface WizardStepIndicatorProps {
    index: number
    currentIndex: number
    stepIndicator: WizardStepIndicatorType
}

const WizardStepIndicator = ({ index, currentIndex, stepIndicator }: WizardStepIndicatorProps) => {
    const displayDoneIconAction = stepIndicator.displayFinishedIconAction || 'after'

    const stepIsCompleted = (): boolean => {
        if (displayDoneIconAction === 'after') {
            return index < currentIndex
        } else {
            return index <= currentIndex
        }
    }

    return (
        <div className={clsx('step-indicator-container', index === currentIndex && 'active')}>
            <div className="step-indicator-icon-background">
                {stepIndicator.icon ? (
                    <img
                        className={clsx('step-indicator-icon', index === currentIndex && 'active')}
                        src={stepIsCompleted() ? ICONS.review : stepIndicator.icon}
                        alt={`step indicator icon for ${stepIndicator.label}`}
                    />
                ) : (
                    <div>
                        <span className={clsx('step-indicator-icon', index === currentIndex && 'active')}>
                            {index + 1}
                        </span>
                    </div>
                )}
            </div>

            <div className={clsx('step-indicator-label', index === currentIndex && 'active')}>
                {stepIndicator.label}
            </div>
        </div>
    )
}

export default WizardStepIndicator
